module.exports = "pegasus/assets/social-profile-preview.png";